module.exports = __webpack_public_path__ + "img/ma.b02d6930.jpg";